import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { useLocale } from '@/hooks';
import { trackClassroomEvent } from '@/shared/features/classroom/utils';
import { DialogBody, DialogHeader, ResponsiveDialog } from '@/ui_v3';
import { ShareContent } from './ShareContent';
interface ClassroomShareModalProps {
  classroomName: string;
  classroomId: string;
  enterCode: string;
  onClose: () => void;
}
interface OpenClassroomShareModalPayload {
  classroom: {
    id: string;
    name: string;
    code: string;
  };
}
export function ClassroomShareModal({
  classroomName,
  classroomId,
  enterCode,
  onClose
}: ClassroomShareModalProps) {
  const {
    t
  } = useTranslation(['common']);
  const {
    locale
  } = useLocale();
  const joinPath = `${locale === 'ko' ? '' : `/${locale}`}/join?code=${encodeURIComponent(enterCode)}`;
  const shareUrl = typeof window === 'undefined' ? joinPath : `${window.location.origin}${joinPath}`;
  return <ResponsiveDialog size="md" className="max-mobile-lg:inset-x-0 max-mobile-lg:mx-0 max-mobile-lg:!w-full max-mobile-lg:max-w-none" onClose={onClose} forceDrawerOnMobile data-sentry-element="ResponsiveDialog" data-sentry-component="ClassroomShareModal" data-sentry-source-file="ClassroomShareModal.tsx">
      <DialogHeader title={t('common:classroom.inviteTitle')} hasCloseButton={true} onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="ClassroomShareModal.tsx" />
      <DialogBody className="flex min-h-0 flex-col items-center gap-md overflow-auto px-md pb-lg mobile-lg:px-lg" data-sentry-element="DialogBody" data-sentry-source-file="ClassroomShareModal.tsx">
        <ShareContent title={classroomName} enterCode={enterCode} shareUrl={shareUrl} place="classroom_invite" contentType="CLASSROOM" contentId={classroomId} classroomId={classroomId} data-sentry-element="ShareContent" data-sentry-source-file="ClassroomShareModal.tsx" />
      </DialogBody>
    </ResponsiveDialog>;
}
export const openClassroomShareModal = ({
  classroom
}: OpenClassroomShareModalPayload) => {
  if (typeof window === 'undefined') return;
  trackClassroomEvent('view_classroom_invite_modal', {
    source: 'invite_classroom_modal',
    classroomId: classroom.id
  });
  overlay.open(({
    unmount
  }) => <ClassroomShareModal classroomName={classroom.name} classroomId={classroom.id} enterCode={classroom.code} onClose={unmount} />);
};